// Helpers for detecting club-level access blocks returned by the API.
// The tenant middleware returns HTTP 403 with a `code` field when a club's
// subscription is suspended/cancelled — components use this to show a
// professional access panel instead of empty "0 records" lists.

export const isClubSuspended = (error) =>
  error?.response?.data?.code === 'CLUB_SUSPENDED' ||
  error?.response?.data?.code === 'SUBSCRIPTION_EXPIRED';

export const isClubCancelled = (error) =>
  error?.response?.data?.code === 'CLUB_CANCELLED';

// True for any club access block (suspended / expired / cancelled).
export const isClubBlocked = (error) => isClubSuspended(error) || isClubCancelled(error);
